const BUBBLES = [
  { l: "4%", s: 8, d: 15, delay: 0 },
  { l: "9%", s: 12, d: 12, delay: 3 },
  { l: "15%", s: 5, d: 18, delay: 6 },
  { l: "21%", s: 9, d: 14, delay: 1 },
  { l: "27%", s: 14, d: 11, delay: 4 },
  { l: "33%", s: 6, d: 17, delay: 8 },
  { l: "39%", s: 10, d: 13, delay: 2 },
  { l: "45%", s: 7, d: 19, delay: 5 },
  { l: "51%", s: 13, d: 12, delay: 9 },
  { l: "57%", s: 5, d: 16, delay: 1.5 },
  { l: "62%", s: 11, d: 14, delay: 6.5 },
  { l: "68%", s: 8, d: 18, delay: 3.5 },
  { l: "74%", s: 16, d: 11, delay: 7 },
  { l: "80%", s: 6, d: 20, delay: 2.5 },
  { l: "86%", s: 10, d: 13, delay: 5.5 },
  { l: "92%", s: 7, d: 17, delay: 8.5 },
  { l: "96%", s: 12, d: 15, delay: 4.5 },
];

export function UnderwaterBg() {
  return (
    <div className="underwater" aria-hidden="true" data-testid="underwater-bg">
      <div className="caustics" />
      <div className="rays" />
      {BUBBLES.map((b, i) => (
        <span
          key={i}
          className="bubble"
          style={{ left: b.l, width: b.s, height: b.s, animationDuration: `${b.d}s`, animationDelay: `${b.delay}s` }}
        />
      ))}
    </div>
  );
}
